webpackJsonp([20],{

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  default: {
    primary: 'indigo',
    accent: 'pink'
  },
  red: {
    primary: 'red',
    accent: 'blue'
  },
  pink: {
    primary: 'pink',
    accent: 'teal'
  },
  purple: {
    primary: 'purple',
    accent: 'green'
  },
  deepPurple: {
    primary: 'deep-purple',
    accent: 'lime'
  },
  indigo: {
    primary: 'indigo',
    accent: 'pink'
  },
  blue: {
    primary: 'blue',
    accent: 'red'
  },
  lightBlue: {
    primary: 'light-blue',
    accent: 'orange'
  },
  cyan: {
    primary: 'cyan',
    accent: 'lime'
  },
  teal: {
    primary: 'teal',
    accent: 'pink'
  },
  green: {
    primary: 'green',
    accent: 'purple'
  },
  lightGreen: {
    primary: 'light-green',
    accent: 'yellow'
  },
  lime: {
    primary: 'lime',
    accent: 'deep-purple'
  },
  yellow: {
    primary: 'yellow',
    accent: 'light-green'
  },
  amber: {
    primary: 'amber',
    accent: 'cyan'
  },
  orange: {
    primary: 'orange',
    accent: 'light-blue'
  },
  deepOrange: {
    primary: 'deep-orange',
    accent: 'light-green'
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sk_index_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_index_js__ = __webpack_require__(62);



/* harmony default export */ __webpack_exports__["a"] = ({
  sk: __WEBPACK_IMPORTED_MODULE_0__sk_index_js__["default"],
  en: __WEBPACK_IMPORTED_MODULE_1__en_index_js__["default"]
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/login',
  name: 'login',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(381)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: false
  }
}, {
  path: '/',
  name: 'companies',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(380)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: true
  }
}, {
  path: '/user/:userId/detail',
  name: 'userDetail',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(395)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: true
  }
}, {
  path: '/user/:userId/addCompany',
  name: 'addCompany',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(383)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: true
  }
}, {
  path: '/share/company/:companyId',
  name: 'companyUnauthorized',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(384)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: false
  }
}, {
  path: '/share/service/:serviceId',
  name: 'serviceUnauthorized',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(391)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    auth: false
  }
}, {
  path: '/company/:companyId',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(378)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'addService',
    name: 'addService',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(390)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'dashboard',
    name: 'companyAuthorized',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(234)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true,
      type: 'company'
    }
  }, {
    path: 'settings',
    name: 'companySettings',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(388)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'edit',
    name: 'editCompany',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(385)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'reviews',
    name: 'companyReviews',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(387)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'calendar',
    name: 'calendar',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(382)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'products',
    name: 'products',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(389)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'notifications',
    name: 'notifications',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(386)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }]
}, {
  path: '/service/:serviceId',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(379)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'dashboard',
    name: 'serviceAuthorized',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(234)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true,
      type: 'service'
    }
  }, {
    path: 'settings',
    name: 'serviceSettings',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(394)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'edit',
    name: 'editService',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(392)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }, {
    path: 'reviews',
    name: 'serviceReviews',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(393)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      auth: true
    }
  }]
}]);

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_company__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_settings__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_calendar__ = __webpack_require__(300);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    company: __WEBPACK_IMPORTED_MODULE_3__modules_company__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_4__modules_settings__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_5__modules_calendar__["a" /* default */]
  },
  strict: "production" === 'development'
});

if (false) {
  module.hot.accept(['./modules/auth', './modules/company', './modules/settings', './modules/calendar'], function () {
    var auth = require('./modules/auth').default;
    var company = require('./modules/company').default;
    var settings = require('./modules/settings').default;
    var calendar = require('./modules/calendar').default;

    store.hotUpdate({
      modules: {
        auth: auth,
        company: company,
        settings: settings,
        calendar: calendar
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('truncate', function (text, length, clamp) {
  clamp = clamp || '...';
  length = length || 30;

  if (text.length <= length) {
    return text;
  } else {
    return text.substring(0, length) + clamp;
  }
});

var toArray = function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('pluralize', function (value) {
  var args = toArray(arguments, 1);
  return args.length > 1 ? args[value % 10 - 1] || args[args.length - 1] : args[0] + (value === 1 ? '' : 's');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('uppercase', function (value) {
  return value || value === 0 ? value.toString().toUpperCase() : '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('lowercase', function (value) {
  return value || value === 0 ? value.toString().toLowerCase() : '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (value) {
  if (!value && value !== 0) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value, currency, decimals) {
  var digitsRE = /(\d{3})(?=\d)/g;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('comma', function (value) {
  return value ? value + ', ' : '';
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  decode: function decode(token) {
    var parts = token.split('.');

    var encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    switch (encoded.length % 4) {
      case 0:
        break;
      case 2:
        encoded += '==';
        break;
      case 3:
        encoded += '=';
        break;
    }

    return JSON.parse(decodeURIComponent(atob(encoded)));
  },
  getDeadline: function getDeadline(token) {
    var decoded = this.decode(token);

    if (typeof decoded.exp === 'undefined') return null;

    var deadline = new Date(0);

    deadline.setUTCSeconds(decoded.exp);

    return deadline;
  },
  isExpired: function isExpired(token) {
    var deadline = this.getDeadline(token);

    if (deadline === null) return false;

    var now = new Date();

    return deadline.valueOf() <= now.valueOf();
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(221)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Add',
  addAnotherCompany: 'Add another company',
  addCompany: 'Add a company',
  addPhoto: 'Add a photo',
  addService: 'Add a service',
  back: 'Back',
  close: 'Close',
  delete: 'Delete',
  detail: 'Show',
  edit: 'Edit',
  editPhoto: 'Change a photo',
  forgotPassword: 'Forgot password?',
  switchLanguage: 'Change language',
  login: 'Log in',
  logout: 'Log out',
  logoutConfirm: 'Are you sure you want to log out?',
  no: 'No',
  ok: 'OK',
  register: 'Sign up',
  remove: 'Remove',
  resendEmail: 'Send email',
  save: 'Save',
  send: 'Send',
  select: 'Select',
  yes: 'Yes',
  upload: 'Upload',
  continue: 'Continue'
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  address: 'Address',
  city: 'City',
  companyAutocomplete: 'Enter the address',
  country: 'Country',
  fillManually: 'Fill in manually',
  search: 'Search for address',
  streetAndNumber: 'Street and house number',
  zip: 'ZIP'
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Add client',
  countOfAnimals: 'Number of animals',
  degree: 'Degree',
  firstName: 'First name',
  fullName: 'Full name',
  lastName: 'Last name',
  createdAt: 'Date of creation',
  company: {
    address: 'Address company',
    hasCompany: 'Client has company',
    info: 'Info about company o',
    name: 'Name of company'
  },
  gender: {
    gender: 'Gender',
    male: 'Male',
    female: 'Female'
  },
  profile: {
    addAnimal: 'Add animal | Add animals',
    assignAnimal: 'Assign animal | Assign animals',
    notAssignedAnimals: 'Not assigned animals'
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  billingInfo: 'Billing informations',
  companyName: 'Company name'
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  sendFeedback: 'Send feedback'
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  showAll: 'View all notifications',
  noResults: 'No notifications.'
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Password reset',
  input: 'Your email address',
  success: 'Email with password change link was sent to your email box.'
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Change language'
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  notAvailable: 'Currently not available.',
  noServices: 'This company does not provide any services yet.',
  noGalleryImages: 'You have not uploaded any images yet. You can do so by clicking the \'UPLOAD\' button.',
  unexpectedError: 'Oops! Something went wrong.',
  emailNotConfirmed: {
    header: 'Your email is not verified.',
    message: 'Please check your mailbox. If you have not received a verification email, you can request a resend verification email.'
  },
  addCompany: {
    emailNotVerified: 'You must verify your email for adding a company.'
  },
  login: {
    badCredentials: 'Incorrect login credentials.'
  },
  register: {
    alreadyExists: 'An account with this email already exists.',
    notValidEmailOrPassword: 'Your email or password is incorrect.',
    passwordsDontMatch: 'These passwords do not match.'
  },
  resetPassword: {
    emailNotValid: 'An email is not correct.'
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  animal: 'Animal | Animals',
  client: 'Client | Clients',
  company: 'Company',
  companyName: 'Company name',
  description: 'Description',
  email: 'Email',
  firstName: 'First name',
  fullName: 'First and last name',
  lastName: 'Last name',
  name: 'Name',
  degree: 'Degree',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  nofilled: 'No filled',
  notification: 'Notification | Notifications',
  orgId: 'Company ID',
  password: 'Password',
  passwordConfirm: 'Confirm your password',
  phone: 'Mobile phone',
  searchPlaceholder: 'Search...',
  service: 'Service | Services',
  settings: 'Settings',
  time: 'Time',
  user: 'User',
  vatId: 'VAT ID',
  vatPayer: 'VAT payer',
  image: 'Image | Images',
  businessHours: 'Opening hours'
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  deleteConfirm: 'Are you sure you want to delete this service?',
  registrationSuccessHeader: 'Registration was successful',
  registrationSuccessContent: 'You can log in now. A verification email has been sent to your email box. Without verification of your email address, you will not have access to some features.',
  switchTooltip: 'Click here to select a company/service or add service'
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  administration: 'Administration',
  companies: 'Companies',
  companyAuthorized: 'Home',
  companyReviews: 'Reviews',
  dashboard: 'Home',
  editCompany: 'Edit',
  editService: 'Edit',
  navigation: 'Navigation',
  serviceAuthorized: 'Home',
  calendar: 'Calendar',
  products: 'Products',
  serviceReviews: 'Reviews',
  services: 'Services'
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  rows: 'Lines',
  separator: 'from',
  selected: 'selected'
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Add company to user'
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  avatar: 'Service photo / Logo',
  callToAction: 'Select a type of service',
  header1: 'Add service to company',
  header2: 'Add photos for service',
  header3: 'Add opening hours for service'
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  date: 'Date',
  week: 'Week',
  settings: 'Calendar settings:',
  createCalendar: 'Create Calendar',
  createEvent: 'Create event',
  selectCalendar: 'Select calendar',
  publicCalendar: 'Public calendar',
  calendarDesc: 'For the public calendar, it is necessary to enter the ordering hours',
  selectColor: 'Select a calendar color',
  assignedService: 'Assigned service',
  type: {
    month: 'Month calendar',
    week: 'Week calendar',
    day: 'Day calendar'
  },
  bookingHours: {
    open: 'Opening at',
    close: 'Closing at',
    closed: 'Closed'
  },
  event: {
    add: 'Add event',
    createdBy: 'Created by',
    description: 'Description',
    durationInMinutes: 'Duration in minutes',
    name: 'Name',
    products: 'Products',
    searchAnimal: 'Find the animal and assign it to the event',
    startDate: 'Starting date',
    startTime: 'Start time',
    warning: 'Note the time of your event overlaps with the time of another event:'
  },
  status: {
    PROPOSED: 'Proposed',
    CONFIRMED: 'Confirmed',
    CANCELED: 'Canceled',
    DELETED: 'Deleted'
  },
  types: {
    REMINDER: 'Reminder',
    APPOINTMENT: 'Appointment'
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  register: 'Sign up'
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Name',
  durationInMins: 'Duration in minutes',
  createProduct: 'Create product'
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  deleteReview: 'Delete review',
  deleteReviewConfirm: 'Are you sure you want to delete this review?'
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Add service',
  ambulance: 'Ambulance',
  hotel: 'Accommodation',
  salon: 'Salon',
  service: 'Service | Services',
  shelter: 'Shelter',
  trainer: 'Training',
  walking: 'Walking'
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  settings: 'Settings'
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  additionalServices: 'Additional services',
  capacity: 'Capacity',
  equipment: 'Equipment',
  equipmentAndServices: 'Equipment and services',
  focusAnimals: 'Focus on pets',
  info: 'Informations',
  roomsCount: 'Room count',
  roomsTypes: 'Room types',
  service: 'Service | Services',
  serviceName: 'Service name',
  slug: 'Short and exact service name (without diacritics)',
  id: {
    1: 'Accommodation',
    2: 'Ambulance',
    3: 'Salon',
    4: 'Training',
    5: 'Walking',
    6: 'Shelter'
  },
  type: {
    ambulance: 'Ambulance',
    hotel: 'Accommodation',
    salon: 'Salon',
    trainer: 'Training',
    walking: 'Walking',
    shelter: 'Shelter'
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  loggedUser: 'Logged in'
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Pridať',
  addAnotherCompany: 'Pridať ďalšiu spoločnosť',
  addCompany: 'Pridať spoločnosť',
  addPhoto: 'Pridať fotku',
  addService: 'Pridať službu',
  back: 'Späť',
  close: 'Zatvoriť',
  delete: 'Zmazať',
  detail: 'Zobraziť',
  edit: 'Upraviť',
  editPhoto: 'Nahrať novú fotku',
  forgotPassword: 'Zabudli ste heslo?',
  switchLanguage: 'Zmeniť jazyk',
  login: 'Prihlásiť',
  logout: 'Odhlásiť',
  logoutConfirm: 'Naozaj si prajete sa odhlásiť?',
  no: 'Nie',
  ok: 'OK',
  register: 'Registrovať',
  remove: 'Odstrániť',
  resendEmail: 'Zaslať email',
  save: 'Uložiť',
  send: 'Odoslať',
  select: 'Zvoliť',
  yes: 'Áno',
  upload: 'Nahrať',
  continue: 'Pokračovať'
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  address: 'Adresa',
  city: 'Mesto',
  companyAutocomplete: 'Zadajte adresu',
  country: 'Krajina',
  fillManually: 'Vyplniť manuálne',
  search: 'Vyhľadať adresu',
  streetAndNumber: 'Ulica a číslo domu',
  zip: 'PSČ'
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Pridať klienta',
  countOfAnimals: 'Počet zvierat',
  degree: 'Titul',
  firstName: 'Meno',
  fullName: 'Meno a priezvisko',
  lastName: 'Priezvisko',
  createdAt: 'Dátum vytvorenia',
  company: {
    address: 'Adresa firmy',
    hasCompany: 'Klient zastupuje firmu',
    info: 'Informácie o firme',
    name: 'Názov firmy'
  },
  gender: {
    gender: 'Pohlavie',
    male: 'Muž',
    female: 'Žena'
  },
  profile: {
    addAnimal: 'Pridať zviera | Pridať zvieratá',
    assignAnimal: 'Priradiť zviera | Priradiť zvieratá',
    notAssignedAnimals: 'Nepriradené zvieratá'
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  billingInfo: 'Fakturačné údaje',
  companyName: 'Meno spoločnosti'
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  sendFeedback: 'Odoslať spätnú väzbu'
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  showAll: 'Zobraziť všetky notifikácie',
  noResults: 'Žiadne notifikácie.'
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Obnoviť heslo',
  input: 'Vaša emailová adresa',
  success: 'Email s odkazom na zmenu hesla bol odoslaný do vašej emailovej schránky.'
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Zmeniť jazyk'
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  notAvailable: 'Momentálne nedostupné.',
  noServices: 'Táto spoločnosť neposkytuje zatiaľ žiadne služby.',
  noGalleryImages: 'Žiadne obrázky na zobrazenie. Nahrať ich môžete stlačením tlačidla "NAHRAŤ".',
  unexpectedError: 'Niečo sa pokazilo. Prosíme, skúste svoju akciu opakovať.',
  emailNotConfirmed: {
    header: 'Váš email nie je overený.',
    message: 'Skontrolujte, prosím Vašu emailovú schránku. Pokiaľ Vám nebol doručený overovací email, môžete si požiadať o opätovné zaslanie.'
  },
  addCompany: {
    emailNotVerified: 'Pre pridanie spoločnosti musíte overiť svoj email.'
  },
  login: {
    badCredentials: 'Nesprávne prihlasovacie údaje.'
  },
  register: {
    alreadyExists: 'Účet s týmto emailom už existuje.',
    notValidEmailOrPassword: 'Email alebo heslo je v nesprávnom tvare.',
    passwordsDontMatch: 'Heslá sa nezhodujú.'
  },
  resetPassword: {
    emailNotValid: 'Zadaný email nie je správny.'
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  animal: 'Zviera | Zvieratá',
  client: 'Klient | Klienti',
  company: 'Spoločnosť',
  companyName: 'Meno spoločnosti',
  description: 'Popis',
  email: 'Email',
  firstName: 'Meno',
  fullName: 'Meno a Priezvisko',
  lastName: 'Priezvisko',
  name: 'Meno',
  degree: 'Titul',
  gender: 'Pohlavie',
  male: 'Mužské',
  female: 'Ženské',
  nofilled: 'Nezadané',
  notification: 'Upozornenie | Upozornenia',
  orgId: 'IČO',
  password: 'Heslo',
  passwordConfirm: 'Potvrdenie hesla',
  phone: 'Telefón',
  searchPlaceholder: 'Vyhľadávanie...',
  service: 'Služba | Služby',
  settings: 'Nastavenia',
  time: 'Čas',
  user: 'Používateľ',
  vatId: 'DIČ / IČ DPH',
  vatPayer: 'Platca DPH',
  image: 'Obrázok | Obrázky',
  businessHours: 'Otváracie hodiny'
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  deleteConfirm: 'Naozaj si prajete zmazať túto službu?',
  registrationSuccessHeader: 'Registrácia prebehla úspešne',
  registrationSuccessContent: 'Teraz sa môžete prihlásiť. Do Vašej emailovej schránky bol odoslaný overovací email. Bez overenia svojej emailovej adresy nebudete mať prístup k niektorým funkciám.',
  switchTooltip: 'Kliknite sem pre výber spoločnosti/služby alebo pridanie služby'
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  administration: 'Spravovať',
  companies: 'Spoločnosti',
  companyAuthorized: 'Domov',
  companyReviews: 'Recenzie',
  dashboard: 'Domov',
  editCompany: 'Upraviť',
  editService: 'Upraviť',
  navigation: 'Navigácia',
  serviceAuthorized: 'Domov',
  calendar: 'Kalendár',
  products: 'Produkty',
  serviceReviews: 'Recenzie',
  services: 'Služby'
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  rows: 'Riadky',
  separator: 'z',
  selected: 'vybraný'
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  header: 'Pridať spoločnosť používateľovi'
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  avatar: 'Obrázok služby / Logo',
  callToAction: 'Vyberte druh služby',
  header1: 'Pridať službu k spoločnosti',
  header2: 'Pridať fotky pre službu',
  header3: 'Pridať otváracie hodiny pre službu'
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  date: 'Dátum',
  week: 'Týždeň',
  settings: 'Nastavenia kalendára:',
  createCalendar: 'Vytvoriť kalendár',
  createEvent: 'Vytvoriť udalosť',
  selectCalendar: 'Vybrať kalendár',
  publicCalendar: 'Verejný kalendár',
  calendarDesc: 'Pre verejný kalendár je potrebné zadať objednákové hodiny',
  selectColor: 'Vyberte farbu kalendára',
  assignedService: 'Priradená služba',
  type: {
    month: 'Mesačný kalendár',
    week: 'Týždenný kalendár',
    day: 'Denný kalendár'
  },
  bookingHours: {
    open: 'Otvára sa o',
    close: 'Zatvára sa o',
    closed: 'Zatvorené'
  },
  event: {
    add: 'Pridať udalosť',
    createdBy: 'Vytvoril',
    description: 'Popis',
    durationInMinutes: 'Trvanie v minútach',
    name: 'Názov udalosti',
    products: 'Úkony',
    searchAnimal: 'Vyhľadajte zviera a priradte ho k udalosti',
    startDate: 'Začiatok dátum',
    startTime: 'Začiatok čas',
    warning: 'Pozor čas Vašej udalosťi sa prekrýva s časom inej udalosti:'
  },
  status: {
    PROPOSED: 'Navrhnuté',
    CONFIRMED: 'Potvrdené',
    CANCELED: 'Zrušené',
    DELETED: 'Zmazané'
  },
  types: {
    REMINDER: 'Pripomienka',
    APPOINTMENT: 'Termín'
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  register: 'Registrácia'
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Názov',
  durationInMins: 'Dlžka trvania v minútach',
  createProduct: 'Vytvoriť produkt'
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  deleteReview: 'Odstrániť recenziu',
  deleteReviewConfirm: 'Naozaj si želáte odstrániť túto recenziu?'
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  add: 'Pridať službu',
  ambulance: 'Ambulancia',
  hotel: 'Ubytovanie',
  salon: 'Salón',
  service: 'Služba | Služby',
  shelter: 'Útulok',
  trainer: 'Tréning',
  walking: 'Venčenie'
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  settings: 'Nastavenia'
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  additionalServices: 'Doplnkové služby',
  capacity: 'Kapacita',
  equipment: 'Vybavenie',
  equipmentAndServices: 'Vybavenie a služby',
  focusAnimals: 'Zameranie na zvieratá',
  info: 'Údaje',
  roomsCount: 'Počet izieb',
  roomsTypes: 'Typy izieb',
  service: 'Služba | Služby',
  serviceName: 'Meno služby',
  slug: 'Krátky a výstižný názov služby (bez diakritiky)',
  id: {
    1: 'Ubytovanie',
    2: 'Ambulancia',
    3: 'Salón',
    4: 'Výcvik',
    5: 'Venčenie',
    6: 'Útulok'
  },
  type: {
    ambulance: 'Ambulancia',
    hotel: 'Ubytovanie',
    salon: 'Salón',
    trainer: 'Výcvik',
    walking: 'Venčenie',
    shelter: 'Útulok'
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  loggedUser: 'Prihlásený'
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apollo__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_apollo__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_themes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_moment__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_sk__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_locale_sk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_locale_sk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_jwt__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_filters__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_roboto_fontface_css_roboto_sass_roboto_fontface_scss__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_roboto_fontface_css_roboto_sass_roboto_fontface_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_roboto_fontface_css_roboto_sass_roboto_fontface_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_scss__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_css_fontello_css__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_css_fontello_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_css_fontello_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__App_vue__);
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_apollo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme(__WEBPACK_IMPORTED_MODULE_10__config_themes__["a" /* default */]);

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_6_vue_apollo__["a" /* default */]({
  defaultClient: __WEBPACK_IMPORTED_MODULE_5__apollo__["a" /* apollo */]
});


var i18n = new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.settings.locale,
  fallbackLocale: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].locale.fallback,
  messages: __WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].subscribe(function (mutation, state) {
  if (mutation.type === 'settings/setLocale') {
    i18n.locale = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.settings.locale;
  }
});




var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: 'history'
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], router);

router.beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.auth.token;
  var forceLogout = false;

  if (to.meta.auth && !token) {
    next({ name: 'login' });
  } else {
    if (token) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/check').then(function (response) {
        if (!response.success) {
          __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/logout');
          next({ name: 'login' });
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/logout');
        next({ name: 'login' });
      });

      if (__WEBPACK_IMPORTED_MODULE_16__utils_jwt__["a" /* default */].isExpired(token)) forceLogout = true;
    }

    if (forceLogout) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('auth/logout');
      next({ name: 'login' });
    } else next();
  }
});






var App = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_21__App_vue___default.a);

new App({
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  router: router,
  apolloProvider: apolloProvider,
  i18n: i18n
}).$mount('#app');

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apollo__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation login($email: String!, $password: String!) {\n    login(email: $email, _password: $password) {\n      id\n      authToken\n      fullName\n      profilePhoto {\n        id\n        url\n      }\n      email\n    }\n  }\n'], ['\n  mutation login($email: String!, $password: String!) {\n    login(email: $email, _password: $password) {\n      id\n      authToken\n      fullName\n      profilePhoto {\n        id\n        url\n      }\n      email\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query {\n    me {\n      id\n      authToken\n    }\n  }\n'], ['\n  query {\n    me {\n      id\n      authToken\n    }\n  }\n']);




var prefix = '_auth.';
var loginMutation = __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject);
var checkQuery = __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject2);

var state = {
  isLogged: !!localStorage.getItem(prefix + 'token'),
  token: localStorage.getItem(prefix + 'token') || null,
  user: JSON.parse(localStorage.getItem(prefix + 'user')) || null
};

var mutations = {
  loginSuccess: function loginSuccess(state, payload) {
    state.token = payload.authToken;
    state.user = payload;

    localStorage.setItem(prefix + 'user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload));
    localStorage.setItem(prefix + 'token', payload.authToken);
  },
  loginFail: function loginFail(state, payload) {
    state.token = state.user = null;

    localStorage.removeItem(prefix + 'user');
    localStorage.removeItem(prefix + 'token');
  },
  logout: function logout(state, payload) {
    state.token = state.user = null;
    __WEBPACK_IMPORTED_MODULE_4__apollo__["a" /* apollo */].resetStore();

    localStorage.removeItem(prefix + 'user');
    localStorage.removeItem(prefix + 'token');
  },
  update: function update(state, payload) {
    state.user = payload;

    localStorage.setItem(prefix + 'user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload));
  }
};

var actions = {
  login: function login(_ref, params) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apollo__["a" /* apollo */].mutate({
        mutation: loginMutation,
        fetchPolicy: 'network-only',
        variables: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      }).then(function (response) {
        if (response.data.login) {
          commit('loginSuccess', response.data.login);
          resolve({ success: true });
        } else {
          commit('loginFail');
          resolve({ success: false, error: 'fail' });
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit;

    commit('logout');
  },
  check: function check() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__apollo__["a" /* apollo */].query({
        query: checkQuery
      }).then(function (response) {
        if (response.data.me) {
          resolve({ success: true, data: response.data.me });
        } else {
          resolve({ success: false, data: response.data.me });
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  update: function update(_ref3, payload) {
    var commit = _ref3.commit;

    commit('update', payload);
  }
};

var getters = {
  user: function user(state, getters) {}
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_localStorage__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var prefix = '_calendar.';

var state = {
  selected: __WEBPACK_IMPORTED_MODULE_0__utils_localStorage__["a" /* default */].get(prefix + 'id') || null,
  date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format() || null,
  selectedEvent: null
};

var mutations = {
  setEvent: function setEvent(state, event) {
    state.selectedEvent = event;
  },
  setDate: function setDate(state, date) {
    state.date = date;
  },
  set: function set(state, payload) {
    state.selected = payload;

    __WEBPACK_IMPORTED_MODULE_0__utils_localStorage__["a" /* default */].set(prefix + 'id', payload);
  },
  clean: function clean(state) {
    state.selected = state.info = null;

    __WEBPACK_IMPORTED_MODULE_0__utils_localStorage__["a" /* default */].remove(prefix + 'id');
  }
};

var actions = {
  set: function set(_ref, calendar) {
    var commit = _ref.commit;

    commit('set', calendar);
  },
  clean: function clean(_ref2) {
    var commit = _ref2.commit;

    commit('clean');
  }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var prefix = '_company.';

var state = {
  selected: localStorage.getItem(prefix + 'id') || null,
  info: JSON.parse(localStorage.getItem(prefix + 'info')) || null
};

var mutations = {
  set: function set(state, payload) {
    state.selected = payload.id;
    state.info = payload;

    localStorage.setItem(prefix + 'id', payload.id);
    localStorage.setItem(prefix + 'info', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
  },
  clean: function clean(state) {
    state.selected = null;
    state.info = null;

    localStorage.removeItem(prefix + 'id');
    localStorage.removeItem(prefix + 'info');
  }
};

var actions = {
  set: function set(_ref, company) {
    var commit = _ref.commit;

    commit('set', company);
  },
  clean: function clean(_ref2) {
    var commit = _ref2.commit;

    commit('clean');
  }
};

var getters = {
  has: function has(state) {
    return !!state.selected;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var prefix = '_settings.';

var state = {
  locale: localStorage.getItem(prefix + 'locale') || 'en'
};

var mutations = {
  setLocale: function setLocale(state, payload) {
    state.locale = payload;

    localStorage.setItem(prefix + 'locale', payload);
  }
};

var actions = {
  setLocale: function setLocale(_ref, locale) {
    var commit = _ref.commit;

    commit('setLocale', locale);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(key, value) {
    var JsonStringify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return localStorage.setItem(key, JsonStringify ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) : value);
  },
  get: function get(key) {
    var JsonParse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return (JsonParse ? JSON.parse(localStorage.getItem(key)) : localStorage.getItem(key)) || null;
  },
  remove: function remove(key) {
    return localStorage.removeItem(key);
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 84,
	"./af.js": 84,
	"./ar": 91,
	"./ar-dz": 85,
	"./ar-dz.js": 85,
	"./ar-kw": 86,
	"./ar-kw.js": 86,
	"./ar-ly": 87,
	"./ar-ly.js": 87,
	"./ar-ma": 88,
	"./ar-ma.js": 88,
	"./ar-sa": 89,
	"./ar-sa.js": 89,
	"./ar-tn": 90,
	"./ar-tn.js": 90,
	"./ar.js": 91,
	"./az": 92,
	"./az.js": 92,
	"./be": 93,
	"./be.js": 93,
	"./bg": 94,
	"./bg.js": 94,
	"./bn": 95,
	"./bn.js": 95,
	"./bo": 96,
	"./bo.js": 96,
	"./br": 97,
	"./br.js": 97,
	"./bs": 98,
	"./bs.js": 98,
	"./ca": 99,
	"./ca.js": 99,
	"./cs": 100,
	"./cs.js": 100,
	"./cv": 101,
	"./cv.js": 101,
	"./cy": 102,
	"./cy.js": 102,
	"./da": 103,
	"./da.js": 103,
	"./de": 106,
	"./de-at": 104,
	"./de-at.js": 104,
	"./de-ch": 105,
	"./de-ch.js": 105,
	"./de.js": 106,
	"./dv": 107,
	"./dv.js": 107,
	"./el": 108,
	"./el.js": 108,
	"./en-au": 109,
	"./en-au.js": 109,
	"./en-ca": 110,
	"./en-ca.js": 110,
	"./en-gb": 111,
	"./en-gb.js": 111,
	"./en-ie": 112,
	"./en-ie.js": 112,
	"./en-nz": 113,
	"./en-nz.js": 113,
	"./eo": 114,
	"./eo.js": 114,
	"./es": 116,
	"./es-do": 115,
	"./es-do.js": 115,
	"./es.js": 116,
	"./et": 117,
	"./et.js": 117,
	"./eu": 118,
	"./eu.js": 118,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 120,
	"./fi.js": 120,
	"./fo": 121,
	"./fo.js": 121,
	"./fr": 124,
	"./fr-ca": 122,
	"./fr-ca.js": 122,
	"./fr-ch": 123,
	"./fr-ch.js": 123,
	"./fr.js": 124,
	"./fy": 125,
	"./fy.js": 125,
	"./gd": 126,
	"./gd.js": 126,
	"./gl": 127,
	"./gl.js": 127,
	"./gom-latn": 128,
	"./gom-latn.js": 128,
	"./he": 129,
	"./he.js": 129,
	"./hi": 130,
	"./hi.js": 130,
	"./hr": 131,
	"./hr.js": 131,
	"./hu": 132,
	"./hu.js": 132,
	"./hy-am": 133,
	"./hy-am.js": 133,
	"./id": 134,
	"./id.js": 134,
	"./is": 135,
	"./is.js": 135,
	"./it": 136,
	"./it.js": 136,
	"./ja": 137,
	"./ja.js": 137,
	"./jv": 138,
	"./jv.js": 138,
	"./ka": 139,
	"./ka.js": 139,
	"./kk": 140,
	"./kk.js": 140,
	"./km": 141,
	"./km.js": 141,
	"./kn": 142,
	"./kn.js": 142,
	"./ko": 143,
	"./ko.js": 143,
	"./ky": 144,
	"./ky.js": 144,
	"./lb": 145,
	"./lb.js": 145,
	"./lo": 146,
	"./lo.js": 146,
	"./lt": 147,
	"./lt.js": 147,
	"./lv": 148,
	"./lv.js": 148,
	"./me": 149,
	"./me.js": 149,
	"./mi": 150,
	"./mi.js": 150,
	"./mk": 151,
	"./mk.js": 151,
	"./ml": 152,
	"./ml.js": 152,
	"./mr": 153,
	"./mr.js": 153,
	"./ms": 155,
	"./ms-my": 154,
	"./ms-my.js": 154,
	"./ms.js": 155,
	"./my": 156,
	"./my.js": 156,
	"./nb": 157,
	"./nb.js": 157,
	"./ne": 158,
	"./ne.js": 158,
	"./nl": 160,
	"./nl-be": 159,
	"./nl-be.js": 159,
	"./nl.js": 160,
	"./nn": 161,
	"./nn.js": 161,
	"./pa-in": 162,
	"./pa-in.js": 162,
	"./pl": 163,
	"./pl.js": 163,
	"./pt": 165,
	"./pt-br": 164,
	"./pt-br.js": 164,
	"./pt.js": 165,
	"./ro": 166,
	"./ro.js": 166,
	"./ru": 167,
	"./ru.js": 167,
	"./sd": 168,
	"./sd.js": 168,
	"./se": 169,
	"./se.js": 169,
	"./si": 170,
	"./si.js": 170,
	"./sk": 28,
	"./sk.js": 28,
	"./sl": 171,
	"./sl.js": 171,
	"./sq": 172,
	"./sq.js": 172,
	"./sr": 174,
	"./sr-cyrl": 173,
	"./sr-cyrl.js": 173,
	"./sr.js": 174,
	"./ss": 175,
	"./ss.js": 175,
	"./sv": 176,
	"./sv.js": 176,
	"./sw": 177,
	"./sw.js": 177,
	"./ta": 178,
	"./ta.js": 178,
	"./te": 179,
	"./te.js": 179,
	"./tet": 180,
	"./tet.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tl-ph": 182,
	"./tl-ph.js": 182,
	"./tlh": 183,
	"./tlh.js": 183,
	"./tr": 184,
	"./tr.js": 184,
	"./tzl": 185,
	"./tzl.js": 185,
	"./tzm": 187,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 187,
	"./uk": 188,
	"./uk.js": 188,
	"./ur": 189,
	"./ur.js": 189,
	"./uz": 191,
	"./uz-latn": 190,
	"./uz-latn.js": 190,
	"./uz.js": 191,
	"./vi": 192,
	"./vi.js": 192,
	"./x-pseudo": 193,
	"./x-pseudo.js": 193,
	"./yo": 194,
	"./yo.js": 194,
	"./zh-cn": 195,
	"./zh-cn.js": 195,
	"./zh-hk": 196,
	"./zh-hk.js": 196,
	"./zh-tw": 197,
	"./zh-tw.js": 197
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actions.js": 252,
	"./address.js": 253,
	"./client.js": 254,
	"./company.js": 255,
	"./components/feedback.js": 256,
	"./components/notifications.js": 257,
	"./components/resetPassword.js": 258,
	"./components/switchLang.js": 259,
	"./errors.js": 260,
	"./globals.js": 261,
	"./index.js": 62,
	"./messages.js": 262,
	"./navigation.js": 263,
	"./pagination.js": 264,
	"./routes/addCompany.js": 265,
	"./routes/addService.js": 266,
	"./routes/calendar.js": 267,
	"./routes/login.js": 268,
	"./routes/product.js": 269,
	"./routes/reviews.js": 270,
	"./routes/services.js": 271,
	"./routes/settings.js": 272,
	"./service.js": 273,
	"./state.js": 274
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actions.js": 275,
	"./address.js": 276,
	"./client.js": 277,
	"./company.js": 278,
	"./components/feedback.js": 279,
	"./components/notifications.js": 280,
	"./components/resetPassword.js": 281,
	"./components/switchLang.js": 282,
	"./errors.js": 283,
	"./globals.js": 284,
	"./index.js": 63,
	"./messages.js": 285,
	"./navigation.js": 286,
	"./pagination.js": 287,
	"./routes/addCompany.js": 288,
	"./routes/addService.js": 289,
	"./routes/calendar.js": 290,
	"./routes/login.js": 291,
	"./routes/product.js": 292,
	"./routes/reviews.js": 293,
	"./routes/services.js": 294,
	"./routes/settings.js": 295,
	"./service.js": 296,
	"./state.js": 297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apollo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(240);





var networkInterface = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* createNetworkInterface */])({
  uri: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api.graphql,
  transportBatching: true
});

networkInterface.use([{
  applyMiddleware: function applyMiddleware(req, next) {
    var token = localStorage.getItem('_auth.token') ? localStorage.getItem('_auth.token') : null;

    if (!req.options.headers) {
      req.options.headers = {};
    }
    if (token) {
      req.options.headers.authorization = 'Bearer ' + token;
    }
    next();
  }
}]).useAfter([{
  applyAfterware: function applyAfterware(_ref, next) {
    var response = _ref.response;

    if (response.status === 500) {
      console.error('Server returned an error', response);
    }
    next();
  }
}]);

var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["b" /* ApolloClient */]({
  networkInterface: networkInterface,
  connectToDevTools: true,
  dataIdFromObject: function dataIdFromObject(result) {
    if (result.id && result.__typename) {
      return result.__typename + result.id;
    }
    return null;
  }
});

var apollo = apolloClient;

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  api: {
    graphql:  true ? 'https://graphql.app.snootik.com/graphql' : 'https://graphql.app.snootik.com/graphql',
    websocket: 'ws://api.snootik.com'
  },
  locale: {
    list: [{
      name: 'Slovak',
      slug: 'sk'
    }, {
      name: 'English',
      slug: 'en'
    }],
    fallback: 'en'
  },
  debug: "production" === 'development'
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var context = __webpack_require__(374);
var autoLoaded = {};

context.keys().forEach(function (filename) {
  var queryKey = filename.split('/').pop().replace(/.js/i, '');
  if (queryKey !== 'index') autoLoaded[queryKey] = context(filename).default;
});

/* harmony default export */ __webpack_exports__["default"] = (autoLoaded);

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var context = __webpack_require__(375);
var autoLoaded = {};

context.keys().forEach(function (filename) {
  var queryKey = filename.split('/').pop().replace(/.js/i, '');
  if (queryKey !== 'index') autoLoaded[queryKey] = context(filename).default;
});

/* harmony default export */ __webpack_exports__["default"] = (autoLoaded);

/***/ })

},[298]);


// WEBPACK FOOTER //
// static/js/app.5d0e09413173e0b1cd8d.js